import React from 'react'

import { Box, Colors, Icon, Tabs, Text } from '@factorialco/deprecated-design-system'
import ImageAdvantages from 'assets/images/it-management-landing-2.png'
import ImageProblems from 'assets/images/it-management-landing-3.png'

import i18n from 'modules/core/lib/i18n'

const TabIds = {
  ADVANTAGES: 'advantages',
  PROBLEMS: 'problems',
}

interface TabItemProps {
  item: string
  icon: React.ComponentProps<typeof Icon.Large>['icon']
  color: Colors
}

const TabItem = ({ item, icon, color }: TabItemProps) => {
  return (
    <Box gap="s16" flexDirection="row" alignItems="center">
      <Box minWidth="fit-content">
        <Icon.Large icon={icon} color={color} />
      </Box>
      <Box>
        <Text.Normal weight="medium" color="grey1000">
          {item}
        </Text.Normal>
      </Box>
    </Box>
  )
}

const ComparisonBlock = () => {
  const advantagesList = [
    i18n.t('software_management.initial_setup.comparison_block.advantages.items.first'),
    i18n.t('software_management.initial_setup.comparison_block.advantages.items.second'),
    i18n.t('software_management.initial_setup.comparison_block.advantages.items.third'),
    i18n.t('software_management.initial_setup.comparison_block.advantages.items.fourth'),
    i18n.t('software_management.initial_setup.comparison_block.advantages.items.fifth'),
  ]
  const problemsList = [
    i18n.t('software_management.initial_setup.comparison_block.problems.items.first'),
    i18n.t('software_management.initial_setup.comparison_block.problems.items.second'),
    i18n.t('software_management.initial_setup.comparison_block.problems.items.third'),
    i18n.t('software_management.initial_setup.comparison_block.problems.items.fourth'),
  ]

  const [currentTab, setCurrentTab] = React.useState(TabIds.ADVANTAGES)

  return (
    <Box alignItems="center" paddingX="s64" paddingY="s32" gap="s32">
      <Box gap="s8" maxWidth="s600" textAlign="center">
        <Text weight="semibold" size="500" color="grey1000">
          {i18n.t('software_management.initial_setup.comparison_block.title')}
        </Text>
        <Text.Normal weight="medium">
          {i18n.t('software_management.initial_setup.comparison_block.description')}
        </Text.Normal>
      </Box>

      <Box flexDirection="row" maxWidth="narrowPage">
        <Box width="s600">
          <Tabs currentId={currentTab} onTabClicked={setCurrentTab}>
            <Tabs.Tab
              id={TabIds.ADVANTAGES}
              label={i18n.t('software_management.initial_setup.comparison_block.advantages.title')}
            >
              <Box gap="s24" paddingTop="s32">
                {advantagesList.map((item, index) => (
                  <TabItem key={index} item={item} icon="check" color="viridian1000" />
                ))}
              </Box>
            </Tabs.Tab>

            <Tabs.Tab
              id={TabIds.PROBLEMS}
              label={i18n.t('software_management.initial_setup.comparison_block.problems.title')}
            >
              <Box gap="s24" paddingTop="s32">
                {problemsList.map((item, index) => (
                  <TabItem key={index} item={item} icon="delete-cross" color="radicalRed1000" />
                ))}
              </Box>
            </Tabs.Tab>
          </Tabs>
        </Box>
        <Box width="s400">
          {currentTab === TabIds.ADVANTAGES && <img width="100%" src={ImageAdvantages} />}
          {currentTab === TabIds.PROBLEMS && <img width="100%" src={ImageProblems} />}
        </Box>
      </Box>
    </Box>
  )
}

export default ComparisonBlock
